// AWS Amplify settings.
export const APIConfig = {
  development: {
    baseUrl: 'http://localhost:5000/'
  },
  production: {
    baseUrl: 'https://fisaevents.azurewebsites.net/'
  },
};
